<div class="content col-md-10 container-fluid">
    <br>
    <div class=" static container-fluid mr-0 ml-0 pl-0">
        <img src="assets/svg/Page 4.svg" alt="">
    </div>
    <div class="container-fluid progress-heading row mt-3 mr-0 ml-0">
        <div class="col-md-3 pr-0 pl-0 ">
            <h6 class="text-center step pr-5">Step 1</h6>
            <h6 class="text-center info">General Information</h6>
        </div>
        <div class="col-md-3 pl-0 pr-0 ">
            <h6 class="text-center step pr-5">Step 2</h6>
            <h6 class="text-center info ">Capabilities</h6>
        </div>
        <div class="col-md-3 pr-0 pl-0">
            <h6 class="text-center step pr-3">Step 3</h6>
            <h6 class="text-center info ">Terms & Conditions</h6>
        </div>
        <div class="col-md-3 pr-0 pl-0">
            <h6 class="text-center step ">Step 4</h6>
            <h6 class="text-center info ">Completed</h6>
        </div>
    </div>
    <div class="message row  ">
        <div class="img">
            <img src="assets/svg/Group 17048.png" alt="">
        </div>
        <div class="verify col-md-7">
            <h6>Thank You for Registering on Truventor!</h6>
            <p class="pl-0 first">Our team is verifying the information and documents you have provided. The verification process might take <span class="orange-text"> 3-4 business days.</span></p>
            <p class="pl-0 second "> Meanwhile checkout our Other offerings.</p>
            <button class="mt-4" (click)="dashboard()">Go to Dashboard</button>
        </div>
    </div>
</div>
<!-- <div class="col-md-12 verification-submitted">
    <div class="container box">


          <div class="verification-pending-text center top-margin-sm">
            <img class="" src="https://res.cloudinary.com/dzz4lppcu/image/upload/v1578151980/verification.png">
                <h2 class="">Verification Pending</h2>
                <p>Thank you for registering your company on <a target="_blank" href="https://truventor.com"> https://truventor.com</a></p>
            </div>
            <div class="next-steps">
              <h2>Next steps:</h2>
              <p>1. We will verify the information and or documents you have provided while registering in the next 3-4 business days. </p>
              <p>2. If the information you provided is satisfactory, we will perform a Manufacturing Feasibility and Quality Audit at your factory/works address on a mutually agreed date. We will communicate the same well in advance through Email, SMS and a call. </p>
                <p>3. Once your company Passes the Audit, you are required to sign an NDA to become eligible to start receiving the Purchase Orders from Truventor or it’s customers and gain full access to Truventor’s Manufacturing Partner Panel and it’s allied products. 
                
                </p>
           </div>   

        <div class="col-md-12 no-padding display-flex-lg footer">
            <div class="col-md-7 footer-text no-padding">
                <h4>Need Help?<br>
                        Call: +91-84080-08123  I  Email: support@truventor.com  </h4>
            </div>
            
        </div>
        
    </div>

</div> -->